import { type FragmentOf, graphql } from '@/graphql';

const productPriceFragment = graphql(`
  fragment ProductPriceFragment on Price {
    amount
    currencyCode
  }
`);

const productDiscountedPriceFragment = graphql(
  `
    fragment ProductDiscountedPriceFragment on DiscountedProductPrice {
      originalPrice {
        ...ProductPriceFragment
      }
      discountedPrice {
        ...ProductPriceFragment
      }
    }
  `,
  [productPriceFragment],
);

const productVariantFragment = graphql(`
  fragment ProductVariantFragment on ProductVariant {
    sku
    skuCode
    id: variantId
    variantId
    productId
    selectedOptions {
      name
      value
    }
    inventory {
      retail
    }
  }
`);

//TODO: GROW-1607 Remove oldPrice after all gen3 rings sell out
const productFragment = graphql(
  `
    fragment ProductFragment on Product {
      id
      productKey
      title
      handle
      product_type
      analytics_category
      colorMsgKey
      styleMsgKey
      titleMsgKey
      price {
        ...ProductPriceFragment
      }
      oldPrice {
        ...ProductPriceFragment
      }
      comparePrice {
        ...ProductPriceFragment
      }
      discountedPrice(cartId: $cartId) {
        ...ProductDiscountedPriceFragment
      }
      selectedTraits {
        name
        value
      }
      isRing
      images {
        originalSrc
        thumbnailSrc
        alt
        fullBleedThumbnail
      }
      lineItemImage {
        originalSrc
        alt
      }
      variants(includeInventory: $includeInventory, countryCode: $countryCode) {
        ...ProductVariantFragment
      }
    }
  `,
  [
    productPriceFragment,
    productDiscountedPriceFragment,
    productVariantFragment,
  ],
);

export type ProductFragment = FragmentOf<typeof productFragment>;
export type ProductPriceFragment = FragmentOf<typeof productPriceFragment>;
export type ProductDiscountedPriceFragment = FragmentOf<
  typeof productDiscountedPriceFragment
>;
export type ProductVariantFragment = FragmentOf<typeof productVariantFragment>;

export default productFragment;
